import { useTranslation } from 'react-i18next';
import { useSettingsStore } from '../../store/useSettingsStore';
import { useRole } from '../../hooks/useRole';

function MenuTabs() {
  const { t } = useTranslation();
  const role = useRole();
  const menuTab = useSettingsStore((state) => state.form.menuTab) || 'specials';
  const setForm = useSettingsStore((state) => state.setForm);

  const setMenuTab = (tab) => setForm((c) => ({ ...c, menuTab: tab }));

  const labels = { specials: t('menu.specials'), personalized: t('menu.personalized') };

  return (
    <div className="flex rounded-lg border border-[color:var(--app-border)] bg-[color:var(--app-surface)] p-1">
      {['specials', 'personalized'].map((tab) => (
        <button
          key={tab}
          type="button"
          disabled={role === 'anonymous'}
          className={`flex-1 rounded-md py-2 text-sm font-semibold transition disabled:cursor-not-allowed disabled:opacity-40 ${
            menuTab === tab
              ? 'bg-emerald-500 text-zinc-950 shadow-sm'
              : 'text-[color:var(--app-muted)] hover:text-[color:var(--app-text)]'
          }`}
          onClick={() => setMenuTab(tab)}
        >
          {labels[tab]}
        </button>
      ))}
    </div>
  );
}

export default MenuTabs;